package com.markettwits.waifupics.random.data

import com.markettwits.cache.image.ImageCacheRepository
import com.markettwits.cache.image.FavoriteImageMetadata
import com.markettwits.waifupics.random.cloud.NekoService
import com.markettwits.waifupics.random.model.RandomImageState
import com.markettwits.waifupics.result.HandleNetworkResult

interface RandomImageRepository {

    suspend fun fetchRandomImage(filters: List<String>): RandomImageState

    suspend fun fetchRandomImages(filters: List<String>, limit: Int): List<RandomImageState.Success>

    suspend fun toggleFavorite(
        id: Int,
        width: Int,
        height: Int,
        url: String,
        isProtected: Boolean,
        metadata: FavoriteImageMetadata? = null
    )

    class Base(
        private val service: NekoService,
        private val imageMapperCloud: RandomImageMapperCloud,
        private val handleNetwork: HandleNetworkResult,
        private val cache: ImageCacheRepository
    ) : RandomImageRepository {

        override suspend fun fetchRandomImage(filters: List<String>): RandomImageState {
            val result = handleNetwork.tryRequest {
                service.randomImage(filters).first()
            }
            return result.map(imageMapperCloud)
        }

        override suspend fun fetchRandomImages(filters: List<String>, limit: Int): List<RandomImageState.Success> =
            service.randomImage(filters, limit).map(imageMapperCloud::map)

        override suspend fun toggleFavorite(
            id: Int,
            width: Int,
            height: Int,
            url: String,
            isProtected: Boolean,
            metadata: FavoriteImageMetadata?
        ) {
            cache.addOrDelete(id, width, height, url, isProtected, metadata)
        }
    }
}
